import { DebugLogger } from '@affine/debug';

export const localProviderLogger = new DebugLogger('local-provider');
